import styles from "./LoyaltyOptInModalButtons.css";
import classNames from "classnames";
import {
  ProgressIndicator,
  SIZE_SMALL
} from "@asosteam/asos-web-component-library-progress-indicator";
import { withTranslation } from "../translation";
import PropTypes from "prop-types";
import useOptInControls from "./useOptInControls";

const LoyaltyOptInModalButtons = ({
  loyaltyOptIn,
  loyaltyReject,
  formatTranslation
}) => {
  const {
    isError,
    isOptingIn,
    isRejecting,
    onJoin,
    onReject
  } = useOptInControls({
    loyaltyOptIn,
    loyaltyReject
  });

  const isInProgress = isOptingIn || isRejecting;

  return (
    <>
      <div
        className={classNames("leavesden2", styles.error, {
          [styles.show]: isError
        })}
        aria-live="polite"
      >
        {isError && formatTranslation("quick_join_overlay_error_web")}
      </div>
      <div className={styles.buttonContainer}>
        <button
          className={classNames(
            "london2-button",
            styles.button,
            styles.joinButton
          )}
          disabled={isInProgress}
          onClick={onJoin}
        >
          {isOptingIn ? (
            <ProgressIndicator size={SIZE_SMALL} />
          ) : (
            formatTranslation("quick_join_overlay_join_button_prejoin_web")
          )}
        </button>
        <button
          className={classNames(
            "london2-button",
            styles.button,
            styles.rejectButton
          )}
          disabled={isInProgress}
          onClick={onReject}
        >
          {isRejecting ? (
            <ProgressIndicator size={SIZE_SMALL} />
          ) : (
            formatTranslation("quick_join_overlay_no_thanks_button_prejoin_web")
          )}
        </button>
      </div>
    </>
  );
};

LoyaltyOptInModalButtons.propTypes = {
  loyaltyOptIn: PropTypes.func,
  loyaltyReject: PropTypes.func,
  formatTranslation: PropTypes.func
};

export default withTranslation(LoyaltyOptInModalButtons);
